import { PugTemplateSource } from "./pug-template-source";

export class PugTemplateEngine extends ko.nativeTemplateEngine
   makeTemplateSource: (template) ->
      # Force the compiler to see PugTemplateSource as a real template source.
      return new PugTemplateSource(template)